import $ from 'jquery';
import 'jquery-mask-plugin';
import 'inputmask/dist/jquery.inputmask';
import 'bootstrap';
import 'select2';
import 'maximize-select2-height';
import 'block-ui';
const debounce = require('debounce');

/**
 * Class App
 *
 * @copyright Proprietary
 * @author Vasi <vasi.dascaleanu@dmatrixsoft.com>
 * @author Flavius <flavius.cosmin@dmatrixsoft.com>
 */
class App {
    /**
     * Super.
     */
    constructor() {
        this.date_of_birth = [];
        this.backend_loaded = false;
        this.app_title = document.title;
        this.apply_now_link = decodeURI(document.getElementById('apply_now_btn').href);

        $('.scroll_to_top').on('click tap touch', () => {
            window.scrollTo(0, 0);
        });

        $('.question_name p').on('click', e => {
            let rel = $(e.currentTarget).attr('rel');
            $('.question_content').not(`#${rel}`).slideUp('fast');
            $(`#${rel}`).slideToggle('fast');
            appendInfo();
            appendInfo2();
            $('.question_name').not(`.question-${rel}`).removeClass('opened').addClass('closed');
            $(`.question-${rel}`).toggleClass('opened closed');
        });

        $('.select2:not(#face_amount, #existing_amount)').each((key, e) => {
            $(e).select2({
                minimumResultsForSearch: -1,
                placeholder: $(e).data('placeholder')
            }).maximizeSelect2Height();
        });

        $('#face_amount').select2({
            minimumResultsForSearch: 10,
            placeholder: $('#face_amount').data('placeholder'),
            matcher: (params, data) => {
                if ($.trim(params.term) === '')
                    return data;
                if (data.element.value.toUpperCase().indexOf(params.term.toUpperCase()) === 0)
                    return data;

                return null;
            }
        }).val(null).trigger('change');

        $('#existing_amount').select2({
            minimumResultsForSearch: 10,
            placeholder: $('#existing_amount').data('placeholder'),
            matcher: (params, data) => {
                if ($.trim(params.term) === '')
                    return data;
                if (data.element.value.toUpperCase().indexOf(params.term.toUpperCase()) === 0)
                    return data;

                return null;
            }
        }).trigger('change');

        $('#day').inputmask('99', {
            showMaskOnHover: false,
            jitMasking: true,
            allowMinus: false,
            rightAlign: false
        });
        $('#month').inputmask('99', {
            showMaskOnHover: false,
            jitMasking: true,
            allowMinus: false,
            rightAlign: false
        });
        $('#year').inputmask('9999', {
            showMaskOnHover: false,
            jitMasking: true,
            allowMinus: false,
            rightAlign: false
        });

        const checkValidation2 = () => {
            if (!$('#question-2').hasClass('valid') || !$('#question-3').hasClass('valid') || !$('#question-4').hasClass('valid') || !$('#question-2-1').hasClass('valid') || !$('#question-2-2').hasClass('valid')) {
                $('#submitStep2').addClass('opacity'); //.attr('disabled', true);
            } else {
                $('#submitStep2').removeClass('opacity'); //.attr('disabled', false);
            }

            if ($('#product').val() === 'evolution') {
                if (!$('#question-2').hasClass('valid') || !$('#question-3').hasClass('valid') || !$('#question-4').hasClass('valid') || !$('#question-2-1').hasClass('valid') || !$('#question-2-3').hasClass('valid') || !$('#question-2-4').hasClass('valid')) {
                    $('#submitStep2').addClass('opacity'); //.attr('disabled', true);
                } else {
                    $('#submitStep2').removeClass('opacity'); //.attr('disabled', false);
                }
            }
        }

        const appendInfo = () => {
            if ($.trim($('#client-name').val())) {
                $('.question_info .client-name-info span').text($('#client-name').val());
                $('.question_info .client-name-info').show();
                $('.client-name-info').closest('.question_name').addClass('valid');
            } else {
                $('.question_info .client-name-info span').text('');
                $('.question_info .client-name-info').hide();
            }

            if ($.trim($('#advisor-name').val())) {
                $('.question_info .advisor-name-info span').text($('#advisor-name').val());
                $('.question_info .advisor-name-info').show();
                $('.advisor-name-info').closest('.question_name').addClass('valid');
            } else {
                $('.question_info .advisor-name-info span').text('');
                $('.question_info .advisor-name-info').hide();
            }

            if ($('#question-2').hasClass('valid')) {
                $('.dob-info').text(`${$('#day').val()}-${$('#month').val()}-${$('#year').val()}`);
                $('.dob-info').show();
            } else {
                $('.dob-info').hide();
            }

            if ($('#question-3').hasClass('valid')) {
                if ($('#male').is(':checked')) {
                    $('.gender-info, .gender-info .male').show();
                    $('.gender-info .female').hide();
                } else if ($('#female').is(':checked')) {
                    $('.gender-info, .gender-info .female').show();
                    $('.gender-info .male').hide();
                }
            } else {
                $('.gender-info').hide();
            }

            if ($('#question-4').hasClass('valid')) {
                if ($('#non-smoker').is(':checked')) {
                    $('.smoker-info, .smoker-info .non-smoker').show();
                    $('.smoker-info .smoker').hide();
                } else if ($('#smoker').is(':checked')) {
                    $('.smoker-info, .smoker-info .smoker').show();
                    $('.smoker-info .non-smoker').hide();
                }
            } else {
                $('.smoker-info').hide();
            }

            $('#question-5').addClass('valid');
            $('.province-info').show();
            $('.province-info span').show().text($('#province option:selected').text());
        }

        const checkValidDate = () => {
            if ($('#month').val() === '' && $('#year').val() === '')
                return true;

            let eligibleDates = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
            let day = $('#day').val();
            let month = $('#month').val();
            let year = $('#year').val();
            if ((year % 4 === 0 && year % 100 !== 0) || year % 400 === 0) {
                eligibleDates[1] = 29;
            }

            return day <= eligibleDates[month - 1];
        }

        const validateDob = async () => {
            let validD;
            let validM;
            let validY;

            if ($('#day').val().length === 0 || $('#day').val() > 31 || $('#day').val() < 1) {
                $('#day').addClass('invalid');
                validD = false;
            } else {
                $('#day').removeClass('invalid');
                validD = true;
            }

            if ($('#month').val().length === 0 || $('#month').val() > 12 || $('#month').val() < 1) {
                $('#month').addClass('invalid');
                validM = false;
            } else {
                $('#month').removeClass('invalid');
                validM = true;
            }

            if ($('#year').val().length === 0 || $('#year').val() > (new Date().getFullYear()) || $('#year').val() < (new Date().getFullYear()) - 120 || $('#year').val().length < 4) {
                $('#year').addClass('invalid');
                validY = false;
            } else {
                $('#year').removeClass('invalid');
                validY = true;
            }

            if (validD && validM && validY) {
                if(!checkValidDate()) {
                    $('#day').addClass('invalid');
                    validD = false;
                }
            }

            if (validD && validM && validY) {
                const { near } = await this.dob();
                if(typeof near === 'undefined' || near < 0) {
                    $('#year').addClass('invalid');
                    validY = false;
                }
                if(near < 17) // if age under 17 default to "non-smoker"
                    $('#non-smoker').click();
            }

            if (validD && validM && validY) {
                $('#question-2').removeClass('invalid').addClass('valid');
            } else {
                $('#question-2').addClass('invalid').removeClass('valid');
            }

            checkValidation2();
        }

        const validateGender = () => {
            if (!$('input[name="gender"]').is(':checked')) {
                $('input[name="gender"]').next('label').addClass('invalid');
                $('#question-3').addClass('invalid');
            } else {
                $('label[for="female"], label[for="male"]').removeClass('invalid');
                $('#question-3').removeClass('invalid').addClass('valid');
            }
        }
        $('input[name="gender"]').on('change', () => {
            validateGender();
        });

        const validateSmokingStatus = () => {
            if (!$('input[name="smoker"]').is(':checked')) {
                $('input[name="smoker"]').next('label').addClass('invalid');
                $('#question-4').addClass('invalid');
            } else {
                $('label[for="non-smoker"], label[for="smoker"]').removeClass('invalid');
                $('#question-4').removeClass('invalid').addClass('valid');
            }
        }
        $('input[name="smoker"]').on('change', () => {
            validateSmokingStatus();
        });

        $("#day, #month").on("focusout", e => { // Add 0 before digit if only one digit
            const self = $(e.currentTarget);
            if(self.val())
                self.val((0 + self.val()).slice(-2));
        })

        $('#day, #month, #year').on('keyup blur', async () => {
            await validateDob();
        });

        $('.question-content-3 p').on('click tap touch', async () => {
            await validateDob();
        });

        $('.question-content-4 p').on('click tap touch', async () => {
            await validateDob();
            validateGender();
        });

        $('.question-content-5 p').on('click tap touch', async () => {
            await validateDob();
            validateGender();
            validateSmokingStatus();
        });

        $('.question-content-2-1 p').on('click tap touch', async () => {
            await validateDob();
            validateGender();
            validateSmokingStatus();
        });

        $('.question-content-2-2 p').on('click tap touch', async () => {
            await validateDob();
            validateGender();
            validateSmokingStatus();
            validateAmount();
        });

        $('.question-content-2-4 p').on('click tap touch', () => {
            validateRiskClass();
        });

        $('#product').on('change', e => {
            if ($(e.currentTarget).val() === 'evolution') {
                $('#evolution_fields').slideDown('fast');
            } else {
                $('#evolution_fields').slideUp('fast');
            }
        });

        const validateAmount = () => {
            if ($('#face_amount').val() === '') {
                $('span[aria-labelledby="select2-face_amount-container"], #question-2-1').addClass('invalid');
            } else {
                $('span[aria-labelledby="select2-face_amount-container"], #question-2-1').removeClass('invalid');
                $('#question-2-1').addClass('valid');
            }
        }

        const validateProduct = () => {
            if ($('#product').val() === '') {
                $('span[aria-labelledby="select2-product-container"], #question-2-2').addClass('invalid');
            } else {
                $('span[aria-labelledby="select2-product-container"], #question-2-2').removeClass('invalid');
                $('#question-2-2').addClass('valid');
            }
        }

        const validateRiskClass = () => {
            if ($('#risk-class').val() === '') {
                $('span[aria-labelledby="select2-risk-class-container"], #question-2-3').addClass('invalid');
            } else {
                $('span[aria-labelledby="select2-risk-class-container"], #question-2-3').removeClass('invalid');
                $('#question-2-3').addClass('valid');
            }
        }

        const validateTerm = () => {
            if ($('#term').val() === '') {
                $('span[aria-labelledby="select2-term-container"], #question-2-4').addClass('invalid');
            } else {
                $('span[aria-labelledby="select2-term-container"], #question-2-4').removeClass('invalid');
                $('#question-2-4').addClass('valid');
            }
        }

        $('#face_amount').on('change', () => {
            validateAmount();
        });

        $('#product').on('change', () => {
            validateProduct();
            checkValidation2();
            this.product_selected = $('#product').val();
        });

        $('#risk-class').on('change', () => {
            validateRiskClass();
            this.risk_selected = $('#risk-class').val();
        });

        $('#term').on('change', () => {
            validateTerm();
            this.term_selected = $('#term').val();
        });

        $('#step1').on('change keyup', () => {
            checkValidation2();
        });

        const appendInfo2 = () => {
            if ($('#question-2-1').hasClass('valid')) {
                $('.face_amount-info').show();
                $('.face_amount-info span').text($('#face_amount option:selected').text());
                $('.existing_amount-info').show();
                $('.existing_amount-info span').text($('#existing_amount option:selected').text());
            }
            if ($('#question-2-2').hasClass('valid')) {
                $('.product-info').show();
                $('.product-info span').text($('#product option:selected').text());
            }
            if ($('#question-2-3').hasClass('valid')) {
                $('.risk-class-info').show();
                $('.risk-class-info span').text($('#risk-class option:selected').text());
            }
            if ($('#question-2-4').hasClass('valid')) {
                $('.term-info').show();
                $('.term-info span').text($('#term option:selected').text());
            }
        }

        $('#submitStep2').on('click tap touch', async () => {
            $('#question-1').addClass('valid');
            await validateDob();
            validateGender();
            validateSmokingStatus();
            validateAmount();
            validateProduct();
            if ($('#product').val() === 'evolution') {
                validateRiskClass();
                validateTerm();
            }

            appendInfo();
            appendInfo2();

            if($('#question-1').hasClass('valid') && $('#question-2').hasClass('valid') && $('#question-3').hasClass('valid') && $('#question-4').hasClass('valid') && $('#question-5').hasClass('valid') && $('#question-2-1').hasClass('valid') && $('#question-2-2').hasClass('valid')) {
                let valid = true;
                if ($('#product').val() === 'evolution')
                    valid = !!($('#question-2-3').hasClass('valid') && $('#question-2-4').hasClass('valid'));

                if (valid && this.backend_loaded) {
                    const url = 'summary';
                    const title = `${this.app_title} - Summary`;
                    history.pushState({url: url, title: title }, title, url);
                    document.title = title;

                    $('#submitStep2, .quick_quote').hide();
                    $('#summary, .question_section, #apply_now').show();
                    this.summary();
                }
            }

            $('.summary_preview').show();
            $('.full_summary').hide();
        });

        $('#back').on('click tap touch', () => {
            history.go(-1);
        });

        $('.full_illustration').on('click tap touch', () => {
            const url = 'illustration';
            const title = `${this.app_title} - Illustration`;
            history.pushState({url: url, title: title }, title, url);
            document.title = title;

            $('.summary_preview').hide();
            $('.full_summary').show();
        });

        const checkQuestions = () => {
            if($('#question-2').hasClass('valid') && $('#question-3').hasClass('valid') && $('#question-4').hasClass('valid') && $('#question-5').hasClass('valid') && $('#question-2-1').hasClass('valid')) {
                $('#client-name, #advisor-name, #day, #month, #year').blur();
                $.blockUI({ message: `<h5>${lang.loading}</h5>` });
                this.ajax().catch(console.error);
            }
        }
        const backend = () => {
            if(this.backend_loaded)
                checkQuestions();
        };

        $('#client-name, #advisor-name, #day, #month, #year').on('keyup', debounce(backend, 1000));
        $('input[name="gender"], input[name="smoker"], #province').on('change', backend);

        $('#face_amount, #existing_amount').on('change', () => {
            checkQuestions();
            this.backend_loaded = true;
        });

        this.terms();
        this.provinces();
        $(window).on('popstate', e => {
            const state = e.originalEvent.state;
            if (state !== null) {
                document.title = state.title;
                if(state.url === 'summary') {
                    $('#summary, .summary_preview, #apply_now, .question_section').show();
                    $('.full_summary, .quick_quote, #submitStep2').hide();
                }
                if(state.url === 'illustration') {
                    $('.summary_preview, .quick_quote, #submitStep2').hide();
                    $('#summary .full_summary, #apply_now, .question_section').show();
                }
            } else {
                document.title = this.app_title;
                appendInfo();
                appendInfo2();
                $('.question_name').removeClass('opened').addClass('closed');
                $('.question_content').hide();
                $('#summary, #apply_now, .question_section').hide();
                $('.quick_quote, #submitStep2').show();
            }
        });
    }

    /**
     * This is the header that gets sent to all
     * of our xhr requests.
     *
     * @returns {object}
     */
    headers() {
        return {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
        };
    }

    /**
     * This is the body that gets sent to all
     * of our xhr requests.
     *
     * @returns {string}
     */
    body() {
        let inputs = {};
        for (const [name, value] of new FormData(document.getElementById('step1')).entries())
            inputs[name] = value;

        if(inputs['day'].length === 1)
            inputs['day'] = `0${inputs['day']}`;
        if(inputs['month'].length === 1)
            inputs['month'] = `0${inputs['month']}`;

        inputs['dob'] = `${inputs['year']}-${inputs['month']}-${inputs['day']}`;
        ['month', 'day', 'year'].forEach(e => delete inputs[e]);

        return JSON.stringify(inputs);
    }

    /**
     * Initialize the date of birth field and calculate
     * the real and near ages using the API.
     */
    dob() {
        const calc = async () => {
            const body = this.body();
            if(this.date_of_birth[JSON.parse(body).dob])
                return this.date_of_birth[JSON.parse(body).dob];

            const response = await fetch('/age', {
                method: 'POST',
                headers: this.headers(),
                body: body,
            });

            if(response.ok) {
                return this.date_of_birth[JSON.parse(body).dob] = await response.json();
            } else {
                return false;
            }
        };

        return calc().catch(console.error);
    }

    /**
     * Initialize the province list, the collection comes
     * directly from the API.
     */
    provinces() {
        const province = document.getElementById('province');
        const get = async () => {
            const response = await fetch('/provinces', {
                method: 'POST',
                headers: this.headers(),
                body: this.body(),
            });

            if(response.ok) {
                let options = '';
                for (const [value, province] of Object.entries(await response.json())) {
                    const selected = value === 'ON' ? 'selected' : '';
                    options += `<option value="${value}" ${selected}>${province}</option>`;
                }

                province.innerHTML = options;
            }
        };

        get().catch(console.error);
    }

    /**
     * Do the ajax backend /quote call.
     * @returns {Promise<void>}
     */
    async ajax() {
        const products = $('#product');
        const risks = $('#risk-class');

        const response = await fetch('/quote', {
            method: 'POST',
            headers: this.headers(),
            body: this.body(),
        });

        const res = await response.json();
        window.clearTimeout(window.SESSION_EXPIRE_TIMEOUT);
        window.SESSION_EXPIRE_TIMEOUT = window.setTimeout(() => {
            location.reload();
        }, session_lifetime * 60 * 1000);
        $.unblockUI();

        if(response.ok) {
            products.empty();
            let product_found = false;
            products.append(new Option('', '', false, false));
            for (const { value, name, marketing } of Object.values(this.calculate(res))) {
                if(this.product_selected === value)
                    product_found = true;

                products.append(new Option(name + marketing, value, false, this.product_selected === value));
            }

            risks.empty();
            let risk_found = false;
            risks.append(new Option('', '', false, false));
            for (const risk of Object.values([...new Set(this.evolution.map(item => item.risk))])) {
                if(this.risk_selected === `${risk}`)
                    risk_found = true;

                risks.append(new Option(lang.evolution.risks[risk], `${risk}`, false, this.risk_selected === `${risk}`));
            }

            $('#product_section').show();
            if(!product_found) {
                $('#question-2-2, #question-2-3, #question-2-4').removeClass('valid');
                $('.product-info span, .risk-class-info span, .term-info span').text('');

                $('#evolution_fields').hide();
                $('#submitStep2').addClass('opacity'); //.attr('disabled', true);
            }
            if(this.product_selected === 'evolution') {
                if (!risk_found) {
                    $('#question-2-3, #question-2-4').removeClass('valid');
                    $('.risk-class-info span, .term-info span').text('');
                    $('#submitStep2').addClass('opacity'); //.attr('disabled', true);
                } else risks.change();
            }
        } else {
            $.blockUI({ message: `<h5>Error!</h5><span class="text-muted" style="margin-top: -10px; display: block; padding-bottom: 20px;">Refreshing... If this problem <br /> persists, please contact support.</span>` });
            window.setTimeout(() => {
                location.reload();
            }, 5000);
        }

        this.backend_loaded = true;
    }

    /**
     * Generate the products based on the backend ajax response.
     *
     * @param res
     * @returns {array}
     */
    calculate(res) {
        this.products = {};
        for (const illustration of Object.values(res)) {
            const { product: { owner } } = illustration;
            if(!(owner in this.products))
                this.products[owner] = [];
            this.products[owner].push(illustration);
        }

        let options = [];
        this.evolution = [];
        for (const [owner, illustrations] of Object.entries(this.products)) {
            let array; array = illustrations;
            for (const { snowflake, rates, product: { name, name_fr, term, risk }} of Object.values(array)) {
                if (rates.length) {
                    if (owner === 'evolution') {
                        this.evolution.push({
                            'term': term,
                            'risk': risk,
                            'snowflake': snowflake
                        });
                    } else {
                        options.push({
                            'value': `${owner}-${snowflake}`,
                            'name': lang.locale === 'en' ? name : name_fr,
                            'marketing': '',
                        });
                    }
                }
            }
        }

        if(this.evolution.length !== 0)
            options.unshift({
                'value': 'evolution',
                'name': lang.evolution.name,
                'marketing': lang.evolution.marketing,
            });

        return options;
    }

    /**
     * Update terms when the risk class is selected
     */
    terms() {
        const terms = $('#term');
        $('#risk-class').on('change', e => {
            const filtered = [];
            for (const { term, risk, snowflake } of Object.values(this.evolution))
                if(risk === parseInt($(e.currentTarget).val()))
                    filtered.push({
                        'term': term,
                        'risk': risk,
                        'snowflake': snowflake
                    });

            terms.empty();
            let term_found = false;
            terms.append(new Option('', '', false, false));
            for (const term of Object.values([...new Set(filtered.map(item => item.term))])) {
                if(this.term_selected === `${term}`)
                    term_found = true;

                terms.append(new Option(lang.evolution.terms[term], `${term}`, false, this.term_selected === `${term}`));
            }

            if(!term_found) {
                $('#question-2-4').removeClass('valid');
                $('.term-info span').text('');
                $('#submitStep2').addClass('opacity'); //.attr('disabled', true);
            }
        });
    }

    /**
     * Build summary
     */
    summary() {
        let selection;
        let product = $('#product').val();
        if(product === 'evolution') {
            let id;
            for (const { term, risk, snowflake } of Object.values(this.evolution))
                if (risk === parseInt($('#risk-class').val()) && term === parseInt($('#term').val()))
                    id = snowflake;

            selection = `${product}-${id}`;
        } else selection = product;

        const [ owner, snowflake ] = selection.split('-');
        const found = this.products[owner].find(illustration => illustration.snowflake === parseInt(snowflake));
        if (typeof found !== 'undefined') this.populate(found);
        else alert('product not found!');
    }

    /**
     * Populate DOM with the backend data.
     * @param illustration
     */
    populate(illustration) {
        const locale = lang.locale === 'en' ? 'en-CA' : 'fr-CA';
        const options = { currency: 'CAD', style: 'currency' };
        const { download, product: { name, name_fr, owner, age_type }, rates, rates: [{ monthly, yearly }]} = illustration;
        const product_name = owner === 'evolution' ? lang.evolution.name : (lang.locale === 'en' ? name : name_fr);

        $('#prod_name').toggle(owner !== 'evolution');
        $('#prod_evolution').toggle(owner === 'evolution');
        document.getElementById('summary-product-link').innerHTML = product_name;
        if(owner === 'evolution') {
            const { product: { term, risk }} = illustration;
            document.getElementById('summary-product-link').innerHTML = term === 5 ? `${lang.evolution.terms[term]}` : `${product_name} T${term} ${lang.evolution.risks[risk].replace(/^RC\d - /, '')}`;
        }

        document.getElementById('prod_name').innerHTML = `<p>${product_name}</p>`;
        document.getElementById('summary-monthly-rate').innerHTML = new Intl.NumberFormat(locale, options).format(monthly).replace(/\sCA$/, '');
        document.getElementById('summary-yearly-rate').innerHTML = new Intl.NumberFormat(locale, options).format(yearly).replace(/\sCA$/, '');
        document.getElementById('download-illustration').href = download;
        const day = $('#day').val();
        const month = $('#month').val();
        document.getElementById('apply_now_btn').href = encodeURI(this.apply_now_link
            .replace('{client}', $('#client-name').val())
            .replace('{day}', day.length === 1 ? `0${day}` : day)
            .replace('{month}', month.length === 1 ? `0${month}` : month)
            .replace('{year}', $('#year').val())
            .replace('{gender}', $('input[name="gender"]:checked').val())
            .replace('{smoker}', $('input[name="smoker"]:checked').val() === 'y' ? '1' : '0')
            .replace('{province}', $('#province').val())
            .replace('{face_amount}', $('#face_amount').val())
            .replace('{existing_amount}', $('#existing_amount').val())
            .replace('{locale}', lang.locale === 'en' ? 'en_US' : 'fr_CA'));

        let tbody = '';
        for (const { age, monthly, yearly, coverage, return_of_premium, is_renewal } of Object.values(rates)) {
            tbody += `<tr class="text-${is_renewal ? 'success' : 'dark'}">`;
            tbody += `<td>${ age === 0 ? lang.td_age_zero : age }</td>`;
            tbody += `<td>${new Intl.NumberFormat(locale, options).format(monthly).replace(/\sCA$/, '')}</td>`;
            tbody += `<td>${new Intl.NumberFormat(locale, options).format(yearly).replace(/\sCA$/, '')}</td>`;
            tbody += `<td>${return_of_premium ? lang.td_return : new Intl.NumberFormat(locale, options).format(coverage).replace(/\sCA$/, '')}</td>`;
            tbody += `</tr>`;
        }

        document.getElementById('rates_table').innerHTML = `<thead><tr>
                <th><span>${ age_type === 'rounded' || age_type === 'near' ? lang.th_near_age : lang.th_real_age }</span></th>
                <th><span>${lang.th_monthly_rate}</span></th>
                <th><span>${lang.th_yearly_rate}</span></th>
                <th><span>${lang.th_coverage}</span></th>
            </tr></thead>
            <tbody>${tbody}</tbody>`;

        document.getElementById('disclaimers').innerHTML = `<p>${this.disclaimer(illustration)}</p>`;
    }

    // noinspection DuplicatedCode

    /**
     * Figure out and return the disclaimers.
     *
     * @param illustration
     * @returns {string}
     */
    disclaimer(illustration) {
        let years;
        let interest;
        let output = [];
        let under = false;
        let renewal = false;
        const { snowflake, coverage, rates } = illustration;
        if(typeof coverage === 'undefined') {
            const { product: { return_years, return_interest } } = illustration;
            years = return_years;
            interest = return_interest;
        } else {
            const { coverage: { return_years, return_interest } } = illustration;
            years = return_years;
            interest = return_interest;
        }
        for (const { age, is_renewal } of Object.values(rates)) {
            if(age === 0) under = true;
            if(is_renewal) renewal = true;
        }

        if(under)
            output.push(lang.disclaimers.under);
        if(typeof lang.disclaimers.products[snowflake] !== 'undefined')
            output.push(lang.disclaimers.products[snowflake]);
        if(years !== 0 && typeof lang.disclaimers.years[years] !== 'undefined') {
            if (interest !== 0) output.push(lang.disclaimers.years[years].standard.replace(':interest', interest));
            else output.push(lang.disclaimers.years[years].zero_percent);
        }
        if(renewal)
            output.push(lang.disclaimers.renewal);

        output.push(lang.disclaimers.general);
        return output.join(' &bull; ') + '.';
    }
}

// Initialize application
window.addEventListener('load', () => new App());
